<template>
  <div>
    <b-row class="row-fix">
      <b-col cols="12">
        <!-- jeux -->
        <a v-for="game of games" :href="'/jeu/'+url(game.name)" :key="game.name">
          <b-card :title="game.name"
                  :img-src="backendUrl+'/'+game.iconUrl"
                  img-alt="Img"
                  img-top>
            <div class="card-text" v-html="game.description" >
            </div>
          </b-card>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'GameList',
  data: function() {
    return {
      selected: [],
      games: [],
      backendUrl: Vue.$backend.getBackendUrl(),
      url: Vue.$custom.urlFormat,
    }
  },
  methods: {
    getVariant: function(tag) {
      if (this.selected.indexOf(tag) >= 0) {
        return 'success'
      }
      return 'primary'
    },
    shortDesc: function(html) {
      return html.replace(/<.*?>/g, '')
    },
  },
  filter: () => {
  },
  created: function(){
    if (this.$route.query.tag) {
      this.selected = this.$route.query.tag
      if (!Array.isArray(this.selected)){
        this.selected = [this.selected]
      }
    } else {
      this.selected = []
    }

    Vue.$backend.listGames().then(res => this.games = res)
  },
}
</script>

<style scoped>

.card {
  max-width: calc(33% - 10px);
  display: inline-block;
  margin: 10px 5px;
  height: 400px;
  overflow-y: hidden;
  text-align: center;
}

@media screen and (max-width: 576px) {
  .card {
    max-width: calc(100% - 10px);
  }
}

.card-img-top {
  width: auto;
  height: 100px;
}

a{
  color: black;
}

a:hover{
  color: black;
}

</style>
